import request from "@/utils/request";

export default function agentUnbindDeviceQRCode(id) {
    return request.post(`/device/deviceQRCode/agentUnbindDeviceQRCode/${id}`)
}
